import axios from 'axios';
import { getField, updateField } from 'vuex-map-fields';

const url = 'https://api.bi-assobens.com.br/v1';
// const url = 'http://localhost:3000/v1';

export default {
  namespaced: true,
  state: {
    user: {},
    users: [],
    total: 0,
  },

  mutations: {
    updateField,
    SET_USERS(state, payload) {
      state.users = payload.users;
      state.total = payload.total;
    },
    SET_USER(state, payload) {
      state.user = payload;
    },
  },

  actions: {
    async getUsers({ commit }, obj) {
      const { data } = await axios.get(`${url}/users`, {
        headers: {
          'x-access-token': obj.token,
          'integration-key': '9e1a17ce5b329d3bf3cd0e618cfd83d57084f7944a9236ed2e2e86c2fba865b1',
        },
        params: {
          page: obj.page,
          limit: obj.limit,
          filter: obj.filter ? obj.filter : null,
        },
      });

      commit('SET_USERS', data);
    },

    async getUser({ commit }, obj) {
      const { data } = await axios.get(`${url}/user/${obj.id}`, {
        headers: { 'x-access-token': obj.token },
      });

      commit('SET_USER', data);
    },

    // eslint-disable-next-line
    async updateUser({ commit }, obj) {
      await axios.put(
        `${url}/user/${obj.userId}`,
        { ...obj.data },
        { headers: { 'x-access-token': obj.token } },
      );
    },

    // eslint-disable-next-line
    async updateUserDealers({ commit }, obj) {
      await axios.post(
        `${url}/add-dealers/${obj.userId}`,
        { dealers: obj.dealersIds },
        { headers: { 'x-access-token': obj.token } },
      );
    },

    // eslint-disable-next-line no-unused-vars
    async removeUser({ commit }, obj) {
      await axios.delete(
        `${url}/user/${obj.id}`,
        {},
        {
          headers: { 'x-access-token': obj.token },
        },
      );
    },

    // eslint-disable-next-line
    async sendRegister({ commit }, obj) {
      await axios.post(`${url}/user`, { ...obj });
    },

    // eslint-disable-next-line
    async sendCode({ commit }, obj) {
      await axios.post(`${url}/forgot-password`, { ...obj });
      // await axios.post(`http://localhost:3000/v1/forgot-password`, { ...obj });
    },

    // eslint-disable-next-line
    async changePassword({ commit }, obj) {
      await axios.post(`${url}/change-password`, { ...obj });
      // await axios.post(`http://localhost:3000/v1/change-password`, { ...obj });
    },
  },

  getters: { getField },
};
